"use client";

import SectionWrapper from "../Section/SectionWrapper";
import FooterTop from "./components/FooterTop/FooterTop";
import FooterBottom from "./components/FooterBottom/FooterBottom";
import useAxiosPublicInstance from "@/hooks/useAxiosPublicInstance";
import { useGetInfo } from "antopolis-react-utils/hooks";

const Footer = () => {
  const axiosPublicInstance = useAxiosPublicInstance();
  const { info: data } = useGetInfo({
    axiosInstance: axiosPublicInstance,
    api: "websiteContents/websiteInfo",
  });

  return (
    <div className="bg-primary pt-12 md:pt-20 pb-5 md:pb-14 text-white ">
      <SectionWrapper extraClass={"px-3"}>
        <FooterTop data={data} />
        <FooterBottom socialMediaIcons={data?.socialLinks} />
      </SectionWrapper>
    </div>
  );
};

export default Footer;
